import { MeasureCanvas } from "./MeasureCanvas";

import { getFontSize, getFontWeight } from "../typographyUtils";

/*
  truncates text to fit within a given width
  makes a new measureCanvas if none is provided
  requires a fontTemplate string to be passed in in format "{weightPixels} {sizePixels}px {fontFamily}"
*/
export function truncateText(
	text: string,
	fontTemplate: string,
	maxWidth: number,
	truncationString = "...",
	measureCanvas = new MeasureCanvas()
): string {
	// subtract width of the truncation string from the provided max width so we have the max alowable space for the text
	const trueMaxLength = maxWidth - measureCanvas.getTextWidth(truncationString, fontTemplate);
	const truncatedText =
		truncateRecursivelyOnPixelWidth(measureCanvas, trueMaxLength, text, fontTemplate) + truncationString;

	return truncatedText;
}

/**
 * recurrsively truncates text to fit within a given width
 */
const truncateRecursivelyOnPixelWidth = (
	measureCanvas: MeasureCanvas,
	maxChunkWidth: number,
	text: string = "",
	fontTemplate: string
): string => {
	const firstHalf = text?.slice(0, Math.floor(text?.length / 2));
	const firstHalfLength = measureCanvas.getTextWidth(firstHalf, fontTemplate);

	if (firstHalf.length <= 1) {
		return "";
	}

	if (firstHalfLength > maxChunkWidth) {
		return truncateRecursivelyOnPixelWidth(measureCanvas, maxChunkWidth, firstHalf, fontTemplate);
	}

	const secondHalf = text?.slice(firstHalf.length, text?.length);
	const secondHalfLength = measureCanvas.getTextWidth(secondHalf, fontTemplate);
	const remainingLength = Math.floor(maxChunkWidth - firstHalfLength);

	if (secondHalfLength >= remainingLength) {
		return firstHalf + truncateRecursivelyOnPixelWidth(measureCanvas, remainingLength, secondHalf, fontTemplate);
	}

	return "";
};

/**
 * builds fontTemplate string for measuring text width in px
 */
export const buildFontTemplate = (size: string, weight: string, fontFamily = "Source Sans Pro"): string => {
	const fontSize = getFontSize(size);
	const fontWeight = getFontWeight(weight);

	return `${fontWeight} ${fontSize}px ${fontFamily}`;
};
